import {View, Sync} from 'MWC';
import greenCardOrdeModel from '../models/greenCardOrder.m.js';
import tpl from '../templates/interactive.jsx';
import {apiback} from 'config';
import {formatter, IPhone} from 'MWComponents';

const data = {
    contactPhoneNumber: '+380'
};

export default class extends View {
    template = tpl;

    constructor() {
        super();
        this.state = {
            activeScreen: 'form',
            model: new greenCardOrdeModel(data),
            agreeWithTerms: false,
            productName: ''
        };

        this._initMethods();
    }

    handleChange(event) {
        const data = {
            name: event.target.name,
            value: event.target.value
        };
        this._run(data);
    }
    onBlurHandle(name) {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    }

    _run(data) {
        const model = this.getModel();
        model.run({name: data.name, value: data.value});
        this.setState({model});
    }
    removeBracketsAndSpaces(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '');

        phoneNumber = phoneNumber.replace(/\s/g, '');

        return phoneNumber;
    }

    _phoneFormat = value => {
        if (value instanceof IPhone) {
            return value.toString('contact');
        } else {
            return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
        }
    };

    async sendForm() {
        const {contactPhoneNumber} = this.getModel().fields,
            Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: this.removeBracketsAndSpaces(contactPhoneNumber.value),
                        product: this.props.offerName,
                        utmMarks: this.props.utmParams
                    },
                    hash: '19D3489DS33L320L'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                window.dataLayer.push({event: 'sendgreenform'});
                this.setState({
                    activeScreen: 'success'
                });
            }
        } catch (error) {
            this.setState({
                activeScreen: 'error'
            });
            return error;
        }
    }

    _initMethods() {
        this.handleChange = this.handleChange.bind(this);
        this.onBlurHandle = this.onBlurHandle.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this._phoneFormat = this._phoneFormat.bind(this);
    }
    static displayName = 'Green.Card.Order';
}
